import React from 'react';

import { Flex } from '../../../GlobalComponents/Flex';
import { Container } from '../../../GlobalComponents/Container';
import { RootStates } from '../../../reduxstore';
import { useAppSelector } from '../../../reduxstore/hooks';
import AccountDetails from './components/AccountDetails';
import ChangePassword from './components/ChangePassword';
import ProfileData from './components/ProfileData';

const MyAccount: React.FC = (): JSX.Element => {
	const accountInfo = useAppSelector(
		(state: RootStates) => state.accountReducer.profile
	);

	const { eward_subscription, birthday_promotion_medium, email, phone } =
		accountInfo;

	const freeBirthdayDrink =
		birthday_promotion_medium !== null &&
		birthday_promotion_medium !== 'None'
			? true
			: false;
	return (
		<Container>
			<Flex $flexDirection="column" $rowGap="24px">
				<ProfileData profileData={accountInfo} />
				<AccountDetails
					email={email}
					phone={phone}
					ewardSubscription={eward_subscription}
					freeBirthdayDrink={freeBirthdayDrink}
				/>
				<ChangePassword />
			</Flex>
		</Container>
	);
};

export default MyAccount;
